import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IInfluencerForm {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  desktop_image?: string;
  mobile_image?: string;
  alt_image?: string;
  gradient_start_color?: string;
  gradient_end_color?: string;
  banner_title?: string;
  form_title_text?: string;
  form_title_color?: string;
  form_description_text?: string;
  form_description_color?: string;
  button_text?: string;
  button_text_color?: string;
  button_color?: string;
  verify_text?: string;
  verify_text_color?: string;
  resend_text_color?: string;
  thank_you_mobile_image?: string;
  logo_image?: string;
  logo_alt?: string;
  // Influencer Form 1049
  side_image?: string;
  button_color_2?: string;
  gradient_angle?: string;
}

export async function createInfluencerForm(payload: Partial<IInfluencerForm>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.INFLUENCER_FORM.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateInfluencerForm(id: number, payload: Partial<IInfluencerForm>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.INFLUENCER_FORM.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

